import * as yup from 'yup';
import { Row, Column, EMPTY_ARRAY, RenderConfig, NumberInput, SelectInput } from 'commons-ui';
import { onChangeOfferValueAction } from './helper';

export const constructFormData = (formColumns: any) => {
	const FORM_LAYOUT_CREATE_CONFIG: any = [];

	const generateFormLayout = (keys: string[], prefix: string) => {
		if (keys.length === 0) return;

		const columns = keys.map((key) => new Column([new Row(`${prefix}-${key}`)]));
		FORM_LAYOUT_CREATE_CONFIG.push(new Row(prefix, EMPTY_ARRAY, [...columns]));
	};

	generateFormLayout(formColumns.upi, 'upi');
	generateFormLayout(formColumns.imps, 'imps');
	return FORM_LAYOUT_CREATE_CONFIG;
};

export function constructFormConfig(formColumns: any) {
	const FORM_FIELD_CREATE_CONFIG: any = {};

	const generateFormConfig = (keys: string[], prefix: string) => {
		keys.forEach((key) => {
			const fieldKey = `${prefix}-${key}`;
			FORM_FIELD_CREATE_CONFIG[fieldKey] = new RenderConfig()
				.setName(fieldKey)
				.setLabel(key)
				.setRenderer(NumberInput)
				.setRenderProps({
					isEditable: { create: true, edit: true },
					required: false,
					onChangeCallback: onChangeOfferValueAction
				});
		});
	};

	const generateRenderConfig = (prefix: string, label: string) => {
		FORM_FIELD_CREATE_CONFIG[prefix] = new RenderConfig()
			.setName(prefix)
			.setLabel(label)
			.setRenderProps({
				isArrayField: false,
				isEditable: { create: true, edit: true },
				required: false
			});
	};

	generateRenderConfig('upi', 'UPI Static Traffic Distribution');
	generateFormConfig(formColumns.upi, 'upi');

	generateRenderConfig('imps', 'IMPS Static Traffic Distribution');
	generateFormConfig(formColumns.imps, 'imps');
	return FORM_FIELD_CREATE_CONFIG;
}

export const validationSchema = yup.object().shape({
	message: yup
		.string()
		.test('len', 'Message should be of appropriate length!', (val) => !val || val.length > 1 || val.length < 50)
		.optional()
});

export const addNewPGFormKeys = {
	PG_TYPE: 'pgType',
	PG_NAME: 'pgName',
	VALUE: 'value'
};

export const ADD_NEW_PG_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(addNewPGFormKeys.PG_TYPE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(addNewPGFormKeys.PG_NAME)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(addNewPGFormKeys.VALUE)])])
];

export const PG_TYPE_OPTIONS = [
	{ id: 'imps', label: 'IMPS' },
	{ id: 'upi', label: 'UPI' }
];

export const PG_NAME_OPTIONS = [{ id: 'razorpay', label: 'Razorpay' }];

export const addNewPGFormConfig = {
	[addNewPGFormKeys.PG_TYPE]: new RenderConfig()
		.setName('pgType')
		.setLabel('PG Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: PG_TYPE_OPTIONS,
			required: true
		})
		.setToolTip('PG Type'),
	[addNewPGFormKeys.PG_NAME]: new RenderConfig()
		.setName('pgName')
		.setLabel('PG Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: PG_NAME_OPTIONS,
			required: true
		})
		.setToolTip('PG Name'),
	[addNewPGFormKeys.VALUE]: new RenderConfig()
		.setName('value')
		.setLabel('Value')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: true })
		.setToolTip('Value')
};

export const defaultAddNewPgData = {
	[addNewPGFormKeys.PG_TYPE]: 'imps',
	[addNewPGFormKeys.PG_NAME]: 'razorpay',
	[addNewPGFormKeys.VALUE]: 0
};
